import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const links = [
  { label: "Home", to: "/", id: "nav-home-link" },
  { label: "The Book", to: "/book", id: "nav-book-link" },
  { label: "About", to: "/about", id: "nav-about-link" },
  { label: "Press", to: "/press", id: "nav-press-link" },
  { label: "Contact", to: "/contact", id: "nav-contact-link" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
  }, [open]);

  const linkClass = ({ isActive }) =>
    `font-nav uppercase tracking-[0.22em] text-[0.72rem] literary-link ${
      isActive ? "is-active" : ""
    }`;

  return (
    <header
      data-testid="site-nav"
      className="fixed top-0 left-0 right-0 z-40 transition-colors duration-500"
      style={{
        backgroundColor: scrolled ? "rgba(249, 246, 240, 0.94)" : "rgba(249, 246, 240, 0.0)",
        backdropFilter: scrolled ? "blur(8px)" : "none",
        borderBottom: scrolled ? "1px solid var(--rule)" : "1px solid transparent",
      }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between py-5 md:py-6">
        <Link
          to="/"
          data-testid="nav-brand-link"
          className="font-nav uppercase tracking-chapter text-[0.72rem] md:text-[0.78rem]"
          style={{ color: "var(--ink)" }}
        >
          Rahul&nbsp;Bhaskar
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.id}
              end
              className={linkClass}
              style={{ color: "var(--ink)" }}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          aria-label="Open menu"
          data-testid="mobile-menu-toggle"
          aria-expanded={open}
          className="md:hidden font-nav uppercase tracking-[0.22em] text-[0.7rem]"
          style={{ color: "var(--ink)" }}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden fixed inset-0 z-30 flex flex-col"
          style={{ backgroundColor: "var(--paper)" }}
        >
          <div className="flex-1 flex flex-col items-start justify-center px-10 gap-7">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`${l.id}-mobile`}
                className="font-serif-lit text-3xl"
                style={{ color: "var(--ink)" }}
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
